import { createReducer } from '../../util';
import * as actions from '../actions/rcmAssignment';
import { StatusState } from './common';

const initialStatusState : StatusState = {
    error: false,
    errorMessage: '',
    pending: false,
};

const initialState = {
    data: [],

    list: {
        ...initialStatusState,
    },
     changePrecedence: {
        ...initialStatusState,
    },

    rcmAssignmentCreateUpdateDialog: {
        open:false,
        rowData:null
    },
    rcmAssignmentDeleteDialog: {
        open:false,
        rowData:null
    },


};

export default createReducer(initialState, {
    [actions.RCM_ASSIGNMENT_LANDING_PENDING]: (state) => ({
        ...state,
        list: {
            pending: true,
        },
        data: []
    }),
    [actions.RCM_ASSIGNMENT_LANDING_FULFILLED]: (state, npiRoles) => ({
        ...state,
        list: {
            ...initialStatusState,
        },
        data: npiRoles,
    }),
    [actions.RCM_ASSIGNMENT_LANDING_REJECTED]: (state, errorMessage) => ({
        ...state,
        list: {
            ...initialStatusState,
            error: true,
            errorMessage,
        },
    }),

        [actions.RCM_ASSIGNMENT_CHANGE_PRECEDENCE_PENDING]: (state) => ({
            ...state,
            changePrecedence: {
                pending: true,
            },
        }),
        [actions.RCM_ASSIGNMENT_CHANGE_PRECEDENCE_FULFILLED]: (state) => ({
            ...state,
            changePrecedence: {
                ...initialStatusState,
            },
        }),
        [actions.RCM_ASSIGNMENT_CHANGE_PRECEDENCE_REJECTED]: (state, errorMessage) => ({
            ...state,
            changePrecedence: {
                ...initialStatusState,
                error: true,
                errorMessage,
            },
        }),

        //dialog
    

        [actions.RCM_ASSIGNMENT_CREATE_UPDATE_DIALOG]: (state, rcmAssignmentCreateUpdateDialog) => ({
            ...state,
            rcmAssignmentCreateUpdateDialog
        }),

        [actions.RCM_ASSIGNMENT_DELETE_DIALOG]: (state, rcmAssignmentDeleteDialog) => ({
            ...state,
            rcmAssignmentDeleteDialog
        }),

});
